import { render, staticRenderFns } from "./ProficiencyReport.vue?vue&type=template&id=55524a22&scoped=true"
import script from "./ProficiencyReport.vue?vue&type=script&lang=ts"
export * from "./ProficiencyReport.vue?vue&type=script&lang=ts"
import style0 from "./ProficiencyReport.vue?vue&type=style&index=0&id=55524a22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55524a22",
  null
  
)

export default component.exports